import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http'; // Importamos HttpBackend para saltar interceptores si fuera necesario
import Swal from 'sweetalert2';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EstadoSistemaService {
  private modalAbierto = false;
  private intervaloPing: any = null;
  private http: HttpClient;

  // Usamos HttpBackend para crear un cliente HTTP 'puro' que NO pase por los interceptores
  // para evitar bucles infinitos en el ping de comprobación.
  constructor(private handler: HttpBackend) { 
    this.http = new HttpClient(handler);
  }

  reportarCaidaSistema() {
    if (this.modalAbierto) return;

    this.modalAbierto = true;
    
    // HTML Personalizado para el Modal
    const htmlContent = `
      <div class="repair-card">
        <div class="repair-icon-container">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
          </svg>
        </div>
        <h3 class="repair-title">Diagnóstico en Curso</h3>
        <p class="repair-text">
          Hemos detectado una intermitencia en la red neuronal del servidor. 
          <br>El sistema de <strong>Auto-reparación</strong> está reiniciando los servicios.
        </p>
        
        <div class="repair-loader-track">
          <div class="repair-loader-bar"></div>
        </div>
        
        <p style="margin-top: 15px; font-size: 0.8rem; color: #666;">
          Tiempo estimado: 10 - 30 segundos
        </p>
      </div>
    `;

    Swal.fire({
      html: htmlContent, // Inyectamos nuestro diseño
      width: 450,
      background: 'transparent', // Hacemos transparente el fondo original de Swal
      backdrop: `
        rgba(10, 15, 25, 0.85)
        url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.05' fill-rule='evenodd'/%3E%3C/svg%3E")
        left top
        no-repeat
      `, // Backdrop oscuro con textura sutil y Blur (si el navegador soporta backdrop-filter)
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      customClass: {
        popup: 'swal-repair-popup' // Aplicamos la clase que quita los estilos por defecto
      },
      didOpen: () => {
        // Opcional lógica JS.
      }
    });

    // Iniciar el Ping de Resurrección
    this.iniciarPing();
  }

  // Se llama cuando el sistema revive
  reportarSistemaOperativo() {
    if (this.modalAbierto) {
      this.modalAbierto = false;
      
      this.detenerPing();
      
      Swal.close();
      
      // Toast de éxito
      Swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        icon: 'success',
        title: 'Sistemas en línea',
        text: 'Conexión restablecida correctamente.',
        background: '#1e232d', // Fondo oscuro
        color: '#fff',         // Texto blanco
        iconColor: '#00d2ff'   // Icono azul neón
      });
    }
  }

  
  private iniciarPing() {
    if (this.intervaloPing) return;

    this.intervaloPing = setInterval(async () => {
      try {
        // 2. CORRECCIÓN URL: Apuntamos directo al puerto 3000 para evitar errores de HTML/Nginx        
        const urlBackend = environment.apiUrl;

        // Aseguramos que termine en /health
        // (Si la url ya trae /api, la limpiamos un poco o la forzamos)
        // Esta lógica simple asume que baseUrl apunta a la raíz del backend
        const urlPing = `${urlBackend}/health`.replace('//health', '/health');

        await firstValueFrom(this.http.get(urlPing, { responseType: 'text' }));
        
        // Si llegamos aquí es un 200 OK del Backend real
        this.reportarSistemaOperativo();

      } catch (error: any) {
        console.log('⏳ Backend (Puerto 3000) aun no responde...', error.status);
      }
    }, 5000); // 5 segundos
  }

  private detenerPing() {
    if (this.intervaloPing) {
      clearInterval(this.intervaloPing);
      this.intervaloPing = null;
    }
  }
}